import { ArchiveAppModal } from "./ArchiveAppModal";

export default ArchiveAppModal;
